@if (entry.base?.display) {
  <form [connect]="'payloadStates.' + entry?.formControlAttributes?.connectPath" class="question-class" [formGroup]="form">
    <mat-form-field appearance="outline">
      <mat-label>{{ entry?.formControlAttributes?.label || 'Requested Effective Date'}}</mat-label>
      <mat-select [formControlName]="entry?.formControlAttributes?.formControlName" [id]="entry?.formControlAttributes?.formControlName" (selectionChange)="onEffectiveDateChange($event.value)">
        <!-- Effective Dates -->
        @if (!loadingOptions) {
          @for (option of entry?.selectAttributes?.optionAttributes; track option) {
            <mat-option [value]="option.value">
              {{option.label}}
            </mat-option>
          }
        } @else {
          <mat-option>
            <div class="loading-option">
              <span>Loading Options</span>
              <mat-spinner [diameter]="24"></mat-spinner>
            </div>
          </mat-option>
        }
        <!-- Insert loading indicator option ( so user see this instead of nothing when hitting the dropdown before response )-->
      </mat-select>
      @if (formControls[(entry?.formControlAttributes?.formControlName)]?.errors?.required) {
        <mat-error>Required
        </mat-error>
      }
    </mat-form-field>
  </form>
}